import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyBranch = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/branches',

        modules: [],
        modulesLoading: false,

        partCategories: [],
        partCategoriesLoading: false,
        partCategoryLoading: false,

        partTypes: [],
        partTypesLoading: false,
        partTypeLoading: false,

        partBrands: [],
        partBrandsLoading: false,
        partBrandLoading: false,

        partOrigins: [],
        partOriginsLoading: false,
        partOriginLoading: false,

        partQualities: [],
        partQualitiesLoading: false,
        partQualityLoading: false,

        measurements: [],
        measurementsLoading: false,
        measurementLoading: false,

        paymentMethods: [],
        paymentMethodsLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        modules: state => state.modules,

        partCategories: state => state.partCategories,

        partTypes: state => state.partTypes,

        partBrands: state => state.partBrands,

        partOrigins: state => state.partOrigins,

        partQualities: state => state.partQualities,

        measurements: state => state.measurements,
        
        paymentMethods: state => state.paymentMethods,
    },
};
